module.exports = __webpack_public_path__ + "media/images/creator/home/about-03@3x-b230954e5ed70531fd550fdacfdb4108.png";